import { RichTextEditor as MantineRichTextEditor, RichTextEditorControlProps } from "@mantine/tiptap";
import clsx from "clsx";
import { FunctionComponent } from "react";
import styles from "../rich-text-editor.module.scss";
import { faCode } from "@fortawesome/pro-solid-svg-icons";
import { Icon } from "../../icon";
import { useEditorDisabled } from "../use-editor-disabled";

const CodeIcon = () => <Icon icon={faCode} size="xs" />;

export const Code: FunctionComponent<RichTextEditorControlProps> = ({ className, disabled, ...other }) => {
    const effectiveDisabled = useEditorDisabled(disabled);
    return (
        <MantineRichTextEditor.Code
            className={clsx(styles["control"], className)}
            disabled={effectiveDisabled}
            {...other}
            icon={CodeIcon}
        />
    );
};

Code.displayName = "RichTextEditor.Code";
